import '../../App.css';
import React, { useContext } from "react";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ApiContext } from '../../context/ApiContext';

function ModalCadastrarDominioMapaCalor({ closeModal, currentPage }) {
    const { CadastrarDominioMapaCalor, CadastroDominioMapaCalor, setCadastroDominioMapaCalor } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    const handleChange = (event) => {
        setCadastroDominioMapaCalor({ ...CadastroDominioMapaCalor, [event.target.name]: event.target.value })
    }

    const handleClose = () => {
        setCadastroDominioMapaCalor({ descricao: "" });
        closeModal(false);
    };

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Cadastrar Domínio do Mapa de Calor</h1>
                    <div className="btn-close-modal" onClick={() => closeModal(false)}>
                        <FaTimes />
                    </div>
                </div>
                <form onSubmit={(e) => CadastrarDominioMapaCalor(e, currentPage)}>
                    <div className="modal-content">
                        <Row>
                            <Col xs={11}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control maxLength={255} onChange={handleChange} name="descricao" />
                                </Form.Group>
                            </Col>
                            <Col xs={1}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Cor</Form.Label>
                                    <Form.Control type='color' onChange={handleChange} name="corHexadecimal" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={handleClose}>Cancelar</button>
                        <button type='submit' className="btn-dash btn-criar" style={btnCriar}>Salvar</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalCadastrarDominioMapaCalor